import React, { useState } from "react";

import t from "../../../../Common/utils/translation/translator";
import ProgressBar from "../common/ProgressBar";

// MSC-1778: Component ComparatorLine must be commonalized
import ComparatorLine from "../../../../Retrofit/components/Devices/BundleComparator/ComparatorLine";

const AxisComparatorMechanicalComparatorSelection = ({ compareDatas, ...props }) => {
  const [showMechanical, setMechanical] = useState(true);

  return (
    <div className="AxisComparatorMechanicalComparatorSelection" {...props}>
      <ComparatorLine
        compareData={compareDatas}
        title={t("cartesian.ui.axis_selection.mechanical_values")}
        isSectionHeader
        opened={showMechanical}
        values={compareDatas.map(() => "")}
        onClick={() => setMechanical(!showMechanical)}
      />
      {showMechanical && (
        <>
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.stroke")}
            values={compareDatas.map((bundle) => bundle.calculations?.strokeUtilization || 0)} // Pass percentage values
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar percentage={value} data-testid="progress-bar-strokeUtilization" />
              </div>
            )}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.speed")}
            values={compareDatas.map((bundle) => bundle.calculations?.speedAxisUtilization || 0)} // Pass percentage values
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar percentage={value} data-testid="progress-bar-speedAxisUtilization" />
              </div>
            )}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.acceleration")}
            values={compareDatas.map((bundle) => bundle.calculations?.accelerationUtilization || 0)} // Pass percentage values
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar percentage={value} data-testid="progress-bar-acceleration" />
              </div>
            )}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.force_fx")}
            values={compareDatas.map((bundle) => bundle.calculations?.forceFxUtilization || 0)} // Pass percentage values
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar percentage={value} data-testid="progress-bar-forceFxUtilization" />
              </div>
            )}
          />
          <ComparatorLine
            compareData={compareDatas}
            title={t("cartesian.ui.axis_selection.drive_torque")}
            values={compareDatas.map((bundle) => bundle.calculations?.driveTorqueUtilization || 0)} // Pass percentage values
            renderValue={(value) => (
              <div className="w-full">
                <ProgressBar percentage={value} data-testid="progress-bar-driveTorqueUtilization" />
              </div>
            )}
          />
        </>
      )}
    </div>
  );
};

export default AxisComparatorMechanicalComparatorSelection;
